// extracted by mini-css-extract-plugin
export default {"alignPagination":"styles_alignPagination__6acbZ","pagination":"styles_pagination__Xwmyy","page":"styles_page__J+TAj","active":"styles_active__jPoaF"};